export var MessageRole;
(function (MessageRole) {
    MessageRole["SYSTEM"] = "system";
    MessageRole["ASSISTANT"] = "assistant";
    MessageRole["USER"] = "user";
    MessageRole["GHOST"] = "ghost";
})(MessageRole || (MessageRole = {}));
export var MessageType;
(function (MessageType) {
    MessageType["TEXT"] = "text";
    MessageType["SCREEN_SHARE"] = "screen_share";
    MessageType["CTA"] = "cta";
    MessageType["HANDOFF"] = "handoff";
    MessageType["SYSTEM_EVENT"] = "system_event";
    MessageType["QUALIFICATION"] = "qualification";
})(MessageType || (MessageType = {}));
//# sourceMappingURL=conversation.js.map